import React from 'react';

const inputStyle = {
  width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none',
  boxSizing: 'border-box', fontFamily: 'Arial, Helvetica, sans-serif',
};
const labelStyle = {
  display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6,
  textTransform: 'uppercase', letterSpacing: '0.05em',
};
const DURATION_OPTIONS = [2, 3, 4, 5, 6, 7];

export default function BookingStep1({ form, update, errors, onNext }) {
  const isCustomDuration = !DURATION_OPTIONS.includes(parseInt(form.duration_hours));

  const validate = () => {
    const e = {};
    if (!form.full_name.trim()) e.full_name = 'Full name is required';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email is required';
    if (!form.phone_number?.trim()) e.phone_number = 'Phone number is required';
    if (!form.event_date) e.event_date = 'Event date is required';
    if (!form.start_time) e.start_time = 'Start time is required';
    if (!form.duration_hours || parseInt(form.duration_hours) < 1) e.duration_hours = 'Duration is required';
    if (!form.strip_wordings?.trim()) e.strip_wordings = 'Wordings on the strip are required';
    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    if (form.event_date && form.event_date < today) e.event_date = 'Event date cannot be in the past';
    return e;
  };

  const field = (key, label, type = 'text', placeholder = '', required = true) => (
    <div style={{ marginBottom: 18 }}>
      <label style={labelStyle}>{label}{required && <span style={{ color: '#E34364' }}> *</span>}</label>
      <input
        type={type} value={form[key]} placeholder={placeholder}
        min={type === 'date' ? (() => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`; })() : undefined}
        onChange={e => update({ [key]: e.target.value })}
        style={{ ...inputStyle, borderColor: errors[key] ? '#E34364' : 'rgba(255,255,255,0.1)' }}
      />
      {errors[key] && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#E34364' }}>{errors[key]}</p>}
    </div>
  );

  return (
    <div style={{ background: 'linear-gradient(135deg, #101428 0%, #0D0F20 100%)', borderRadius: 18, padding: 32, border: '1px solid rgba(227,67,100,0.3)' }}>
      <h2 style={{ margin: '0 0 4px', fontSize: 20, color: '#E34364', fontWeight: 700 }}>Event Details</h2>
      <p style={{ margin: '0 0 28px', fontSize: 13, color: '#a0a0b8' }}>Tell us about your event</p>

      {field('full_name', 'Full Name', 'text', 'Jane Smith')}
      {field('email', 'Email Address', 'email', 'you@example.com')}
      {field('phone_number', 'Phone Number', 'tel', '+1 (555) 000-0000')}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={{ marginBottom: 18 }}>
          <label style={labelStyle}>Event Date <span style={{ color: '#E34364' }}>*</span></label>
          <input type="date" value={form.event_date} min={(() => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`; })()}
            onChange={e => update({ event_date: e.target.value })}
            style={{ ...inputStyle, borderColor: errors.event_date ? '#E34364' : 'rgba(255,255,255,0.1)' }} />
          {errors.event_date && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#E34364' }}>{errors.event_date}</p>}
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={labelStyle}>Start Time <span style={{ color: '#E34364' }}>*</span></label>
          <input type="time" value={form.start_time} onChange={e => update({ start_time: e.target.value })}
            style={{ ...inputStyle, borderColor: errors.start_time ? '#E34364' : 'rgba(255,255,255,0.1)' }} />
          {errors.start_time && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#E34364' }}>{errors.start_time}</p>}
        </div>
      </div>

      {/* Duration dropdown */}
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>Duration <span style={{ color: '#E34364' }}>*</span></label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: isCustomDuration ? 10 : 0 }}>
          {DURATION_OPTIONS.map(h => {
            const sel = !isCustomDuration && parseInt(form.duration_hours) === h;
            return (
              <div key={h} onClick={() => update({ duration_hours: h })}
                style={{ cursor: 'pointer', borderRadius: 10, border: `2px solid ${sel ? '#E34364' : 'rgba(255,255,255,0.1)'}`, padding: '10px 0', textAlign: 'center', background: sel ? 'rgba(227,67,100,0.1)' : 'rgba(255,255,255,0.03)', transition: 'all 0.2s' }}>
                <span style={{ fontSize: 14, fontWeight: sel ? 700 : 400, color: sel ? '#E34364' : '#e0e0e0' }}>{h}h</span>
              </div>
            );
          })}
          <div onClick={() => update({ duration_hours: '' })}
            style={{ cursor: 'pointer', borderRadius: 10, border: `2px solid ${isCustomDuration ? '#9F5CFF' : 'rgba(255,255,255,0.1)'}`, padding: '10px 0', textAlign: 'center', background: isCustomDuration ? 'rgba(159,92,255,0.1)' : 'rgba(255,255,255,0.03)', transition: 'all 0.2s', gridColumn: 'span 2' }}>
            <span style={{ fontSize: 13, fontWeight: isCustomDuration ? 700 : 400, color: isCustomDuration ? '#9F5CFF' : '#a0a0b8' }}>Custom</span>
          </div>
        </div>
        {isCustomDuration && (
          <input type="number" min="1" max="24" placeholder="Enter number of hours"
            value={form.duration_hours} onChange={e => update({ duration_hours: e.target.value })}
            style={{ ...inputStyle, borderColor: errors.duration_hours ? '#E34364' : 'rgba(255,255,255,0.1)' }} />
        )}
        {errors.duration_hours && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#E34364' }}>{errors.duration_hours}</p>}
        {parseInt(form.duration_hours) > 2 && (
          <div style={{ marginTop: 10, padding: '10px 14px', background: 'rgba(245,166,35,0.08)', border: '1px solid rgba(245,166,35,0.2)', borderRadius: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 16 }}>ℹ️</span>
            <span style={{ fontSize: 12, color: '#f5a623', lineHeight: '1.4' }}>
              Base package includes <strong>2 hours</strong>. Additional hours will incur extra charges per hour based on the selected booth.
            </span>
          </div>
        )}
      </div>

      {field('strip_wordings', 'Wordings on the Strip', 'text', 'e.g. Sarah\'s Sweet 16 or Mark & Jane 2026')}
      {field('venue_address', 'Venue Address', 'text', '123 Main St, City, State')}

      {/* Event theme */}
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>Event Theme / Description <span style={{ color: '#a0a0b8', textTransform: 'none', fontSize: 11 }}>(optional)</span></label>
        <textarea
          value={form.event_theme_description || ''}
          onChange={e => update({ event_theme_description: e.target.value })}
          placeholder="Describe your event theme, color palette, or any special requests..."
          rows={3}
          style={{ ...inputStyle, resize: 'vertical', fontFamily: 'Arial, Helvetica, sans-serif' }}
        />
      </div>

      <button
        onClick={() => onNext(validate())}
        style={{ width: '100%', background: '#E34364', color: '#fff', border: 'none', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}
      >
        Next: Booth & Add-ons →
      </button>
    </div>
  );
}
